export const API_REPORT_ROUTES = Object.freeze({
    REPORTS: '/report',
    REPORT: '/report/:reportId',
});
